<!-- guest is verified and has image not partial-->
<div
	*ngIf="guest.guest && guest.guest.verified && guest.guest.verified === 'yes' && hasImage && imageUrl && !guest.guest.partialLead"
	class="avatarVerified">
	<div [style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'" class="avatarImage"></div>
</div>

<!-- guest has image and is partial-->
<div *ngIf="guest.guest && hasImage && imageUrl && guest.guest.partialLead"
	class="partialLeadAvatar">
	<div [style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'" class="avatarImage"></div>
</div>

<!-- guest is verified no image and isn't partial-->
<div
	*ngIf="guest.guest && guest.guest.verified && guest.guest.verified === 'yes' && !hasImage && !guest.guest.partialLead"
	class="avatarVerified">
	<app-text-avatar [avatarName]="guest.avatarName" [avatarColor]="guest.color"></app-text-avatar>
</div>

<!-- guest is verified no image and is partial-->
<div
	*ngIf="guest.guest && guest.guest.verified && guest.guest.verified === 'yes' && !hasImage && guest.guest.partialLead"
	class="partialLeadAvatar">
	<app-text-avatar [avatarName]="guest.avatarName" [avatarColor]="guest.color"></app-text-avatar>
</div>


<!-- guest has image is not verified and not partial -->
<div *ngIf="hasImage && guest.guest && guest.guest.verified !== 'yes' && imageUrl && !guest.guest.partialLead"
	[style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'" class="avatarImageUnverified"></div>

<!-- guest has image is not verified and is partial -->
<!-- <div *ngIf="guest.guest && guest.guest.verified !== 'no' && hasImage && imageUrl && guest.guest.partialLead"
	[style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'" class="partialLeadAvatarUnverified"></div> -->

<!-- guest has no image is not verified and not partial-->
<app-text-avatar [avatarName]="guest.avatarName" [avatarColor]="guest.color" class="avatarPlain"
	*ngIf="!hasImage && guest.guest && guest.guest.verified !== 'yes' && !guest.guest.partialLead"></app-text-avatar>

<!-- guest has no image is not verified and is partial-->
<div *ngIf="!hasImage && guest.guest && guest.guest.verified !== 'yes' && guest.guest.partialLead"
	class="partialLeadAvatar">
	<app-text-avatar [avatarName]="guest.avatarName" [avatarColor]="partialLeadColor"></app-text-avatar>
</div>